import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Header from '../../components/Header';
import BreadcrumbNavigation from '../../components/BreadcrumbNavigation';

export default function PerformanceMonitoringDashboard() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <Header />
      <BreadcrumbNavigation />
      <main className="w-full">
        <div className="px-6 py-8">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-8">
            <div className="flex items-start gap-4">
              <AlertTriangle className="w-8 h-8 text-yellow-600 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Monitoramento de Performance Desativado
                </h2>
                <p className="text-gray-700 mb-4">
                  O dashboard de monitoramento de performance em tempo real foi temporariamente desativado para melhorar o desempenho geral do sistema.
                </p>
                <p className="text-gray-600 text-sm">
                  Esta funcionalidade estava consumindo recursos significativos. Caso precise de métricas de performance, entre em contato com o administrador do sistema.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}